import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { Validator } from "../../snippets/Validator";

export class Alarm extends CRUDEntity {

    #validationFields = [
        'trigger_mileage',
        'trigger_date',
        'status',
        'vehicle_id'
    ]

    constructor(id=null) {
        Object.assign(Alarm.prototype, FormActions);
        Object.assign(Alarm.prototype, EntityModalForm);

        super();
        this.entityClass = 'alarm';
        this.urlRoot = '/vehicles-management/alarm';
        this.sectionRootUrl = '/vehicles-management';
        this.id = id;

        Alarm.prototype.delegatedListnersForButtons = function(type, entityClass) {
            daterangepicker.setPicker($('input#alarm_date'), 'MM/DD/YYYY');

            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validationFields){
                $(`#${type}-${entityClass} [name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()

            $(`#${type}-${entityClass} #alarm_type`).on('change', (ev)=>{
                if($(ev.currentTarget).val() == 'Mileage'){
                    $('#alarm_date').val('')
                    $('.trigger_date_container').addClass('d-none')
                    $('.trigger_mileage_container').removeClass('d-none')
                }else{
                    $('#alarm_mileage').val('')
                    $('.trigger_date_container').removeClass('d-none')
                    $('.trigger_mileage_container').addClass('d-none')
                }
            })
            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type == 'create')
                        this.create(()=>setTimeout(() => window.location.reload(), 500));
                    if (type == 'edit')
                        this.update(()=>setTimeout(() => window.location.reload(), 500));
                }
            });
        }
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        let validator
        if($(`#${formId} #alarm_type`).val() == 'Mileage')
            validator = new Validator({'trigger_mileage': ['required', {regexp: /^[0-9]+$/}], 'vehicle_id':['required'], 'status':['required']});
        else
            validator = new Validator({'trigger_date': ['required'], 'vehicle_id':['required'], 'status':['required']});
        let validateFlag = true;
        this.#validationFields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','');
            }else{
                validateFlag = false;
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','border:2px solid #DB3A57 !important;');
            }
        });
        return validateFlag;
    }
}
